// extracted by mini-css-extract-plugin
export default {"labeledText":"labeled-text_labeledText__IshNf","vertical":"labeled-text_vertical__x7C1b"};